<template>
  <div
    class="s-select-dropdown__item toggle-hidden-people h7-text px-6 py-3"
    data-qa="toggle-hidden-people"
    @click.stop="toggleHidden">
    <sIcon
      class="mr-2"
      :type="hide_people ? 'eye' : 'eye-slash'"/>
    {{ !hide_people ? $t('Tenders.HideHidden') : $t('Tenders.ShowHidden') }}
  </div>
</template>

<script>
export default {
  name: 'toggleHiddenPeople',
  props: {
    hide_people: {
      type: Boolean,
      require: true
    },
    toggleHidden: {
      type: Function,
      require: true
    },
  }
}
</script>
<style lang="scss">
.toggle-hidden-people {
  cursor: pointer;
  transition: all 0.35s linear;

  &:hover {
    background: rgba(176, 219, 216, 0.4);
  }
}
</style>
